import {Component, Input} from '@angular/core'
import { fullDayNoYear } from 'utils'
import { Customer } from '../../submission.queries'

@Component({
  selector: 'empty-no-queued-submissions',
  styles: [`
    .fas { color: darkgray; font-size: 120px; }
  `],
  template: `
    <div class="text-center bottom-buffer empty-state">
      <i class="fas fa-folder-open mb-3"></i>
      <h3>No Submissions</h3>
      <p>
        Sit tight while our content team crafts submissions for you to review.
      </p>
      <p>
        Click <a [routerLink]="['/dashboard', customer.id, 'topics']">Requests</a> view, edit, or add new requests.
      </p>
      <div class="top-buffer">
        <a [routerLink]="['/dashboard', customer.id, 'topics']" class="btn btn-primary">Requests</a>
      </div>
    </div>
  `
})
export class EmptyNoQueuedSubmissionsComponent {
  @Input() customer: Customer;

  formatted(date: Date): string {
    return fullDayNoYear(date)
  }

}

